var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { ArrowStrokeDown } from "@epic-ui/icons";
import TextField from "@material-ui/core/TextField";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette, shape = _a.shape, spacing = _a.spacing, typography = _a.typography;
    return ({
        root: {
            flexDirection: "row",
            alignItems: "center",
        },
        label: {
            position: "static",
            transform: "none",
            marginRight: spacing(1),
        },
        labelDisabled: {
            "&&": { opacity: 1 },
        },
        input: {
            border: "1px solid transparent",
            borderRadius: shape.borderRadius,
            "&&": { marginTop: 0 },
        },
        inputFocused: {
            borderColor: palette.text.primary,
        },
        emptyValue: {},
        field: {
            "&&": { minHeight: 0 },
            "&&&": { padding: spacing(0, 5, 0, 1) },
        },
        selectIcon: {
            fontSize: typography.pxToRem(spacing(4)),
            top: "calc(50% - ".concat(spacing(2), "px)"),
            right: 1,
            color: palette.text.primary,
            "&&": { color: palette.text.primary },
        },
        menu: {
            // Fixes a bug with CheckMenuItem
            '& [class*="EuiCheckMenuItem-typography"]': { width: "auto" },
        },
    });
}, { name: "EuiOptionSelect" });
export var OptionSelect = React.forwardRef(function OptionSelect(_a, ref) {
    var _b, _c, _d, _e, _f, _g, _h;
    var className = _a.className, InputProps = _a.InputProps, InputLabelProps = _a.InputLabelProps, SelectProps = _a.SelectProps, props = __rest(_a, ["className", "InputProps", "InputLabelProps", "SelectProps"]);
    var classes = useStyles();
    return (React.createElement(TextField, __assign({}, props, { className: clsx(classes.root, className), InputProps: __assign(__assign({}, InputProps), { disableUnderline: true, classes: __assign(__assign({}, InputProps === null || InputProps === void 0 ? void 0 : InputProps.classes), { root: clsx(classes.input, (_b = InputProps === null || InputProps === void 0 ? void 0 : InputProps.classes) === null || _b === void 0 ? void 0 : _b.root), input: clsx(classes.field, (_c = InputProps === null || InputProps === void 0 ? void 0 : InputProps.classes) === null || _c === void 0 ? void 0 : _c.input), focused: clsx(classes.inputFocused, (_d = InputProps === null || InputProps === void 0 ? void 0 : InputProps.classes) === null || _d === void 0 ? void 0 : _d.focused) }) }), SelectProps: __assign(__assign({ IconComponent: ArrowStrokeDown }, SelectProps), { native: false, classes: __assign(__assign({}, SelectProps === null || SelectProps === void 0 ? void 0 : SelectProps.classes), { icon: clsx(classes.selectIcon, (_e = SelectProps === null || SelectProps === void 0 ? void 0 : SelectProps.classes) === null || _e === void 0 ? void 0 : _e.icon) }), MenuProps: __assign(__assign({}, SelectProps === null || SelectProps === void 0 ? void 0 : SelectProps.MenuProps), { className: clsx(classes.menu, (_f = SelectProps === null || SelectProps === void 0 ? void 0 : SelectProps.MenuProps) === null || _f === void 0 ? void 0 : _f.className), getContentAnchorEl: null, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                } }) }), InputLabelProps: __assign(__assign({}, InputLabelProps), { classes: __assign(__assign({}, InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.classes), { root: clsx(classes.label, (_g = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.classes) === null || _g === void 0 ? void 0 : _g.root), disabled: clsx(classes.labelDisabled, (_h = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.classes) === null || _h === void 0 ? void 0 : _h.disabled) }), shrink: false }), variant: "standard", ref: ref, select: true })));
});
//# sourceMappingURL=OptionSelect.js.map